import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
function Placeholder(props) {
  const { children } = props;
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 3
      },
      "data-testid": "iframe-placeholder",
      children
    }
  );
}
export {
  Placeholder
};
//# sourceMappingURL=Placeholder.js.map
